import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { getConsent, setConsent } from "../utils/analytics";

const CookieConsent = () => {
  const [visible, setVisible] = useState(false);
  const location = useLocation();

  useEffect(() => {
    // Show only if no decision has been recorded yet.
    setVisible(!getConsent());
  }, []);

  // Hide the banner on the mobile PWA (`/app/*`) and on admin pages — those
  // have their own audiences and don't track public-visitor analytics.
  const path = location.pathname || "";
  const isInternalRoute =
    path === "/app" || path.startsWith("/app/") ||
    path === "/admin" || path.startsWith("/admin/");

  const decide = (value) => {
    setConsent(value);
    setVisible(false);
    // Reload so the tracker picks up the change immediately for the current view.
    if (value === "granted") window.location.reload();
  };

  if (!visible || isInternalRoute) return null;

  return (
    <div
      className="fixed bottom-0 inset-x-0 z-[80] p-4 md:p-6 pointer-events-none"
      data-testid="cookie-consent"
    >
      <div className="max-w-4xl mx-auto pointer-events-auto bg-[#0f0f0f] border border-[#262626] rounded-xl shadow-[0_20px_60px_-10px_rgba(0,0,0,0.6)] p-5 md:p-6 backdrop-blur-xl">
        <div className="flex flex-col md:flex-row md:items-start gap-4 md:gap-6">
          <div className="flex-1">
            <h3 className="font-['Bebas_Neue'] text-2xl text-white tracking-wide mb-1">Cookies & Στατιστικα</h3>
            <p className="text-sm text-zinc-400 leading-relaxed">
              Χρησιμοποιουμε ανωνυμα cookies για να καταλαβουμε ποιες σελιδες προτιμας
              και να βελτιωσουμε την εμπειρια σου. Δεν μοιραζομαστε τα δεδομενα σου με
              τριτους. Μπορεις να αλλαξεις την επιλογη σου οποτεδηποτε.
            </p>
          </div>
          <div className="flex gap-2 md:flex-col md:items-stretch">
            <button
              onClick={() => decide("granted")}
              className="px-5 py-2.5 bg-[#F5A623] text-black font-semibold rounded-md hover:bg-[#FF8C00] transition-colors text-sm whitespace-nowrap"
              data-testid="consent-accept"
            >
              Αποδοχη
            </button>
            <button
              onClick={() => decide("denied")}
              className="px-5 py-2.5 border border-[#262626] text-zinc-400 hover:text-white hover:border-[#3a3a3a] rounded-md transition-colors text-sm whitespace-nowrap"
              data-testid="consent-decline"
            >
              Απορριψη
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
